import { usersListingRoutes } from './users-listing/users-listing.routes';

export const usersRoutes = [
  {
    path: '/users',
    name: 'users',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "users" */ './Users.vue'),
    children: [
      ...usersListingRoutes,
      {
        path: ':id',
        name: 'user-profile',
        component: () => import('../profile/Profile.vue')
      }
    ]
  }
];
